var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-control-button block text-xs"},[_c('button',{staticClass:"px-1 py-0 bg-indigo-600",on:{"click":function($event){return _vm.toggleBodyClass('addClass', 'logo-upload')}}},[_vm._v("Upload Logo")])])
}
var staticRenderFns = []

export { render, staticRenderFns }